import type {ConnectElementConfig} from '../../../connect/ConnectJSInterface/ConnectElementList';

export const BillDetailsConfig: ConnectElementConfig = {
  Component: () =>
    import(
      /* webpackChunkName: "BillDetails" */
      '../../../components/Treasury/BillDetails/BillDetails'
    ),
  teamOwner: 'treasury',
  sentryTeam: 'treasury_surfaces',
  releaseState: 'internal',
  description:
    'Shows details for a given bill. Offers editing and payment management.',
  friendlyName: 'Bill details',
};
